import VueNativeEmitter from "./native-emitter";

Vue.use(VueNativeEmitter);